import { cssInterop } from 'nativewind'
import type { ReactNode } from 'react'
import { Platform, View, type ViewProps } from 'react-native'

import { cn } from '@/src/general/utils/cn'

import type { ICON } from '../../general/enums/icons'

type TExtendedBreakpoints = TBreakpoint | '2xl' | '3xl'

export type TIconProps = {
  testID?: string
  name: ICON
  size?: TExtendedBreakpoints
  label?: string
  className?: string
  alt?: string
} & ViewProps

// @ts-expect-error require.context comes from metro
const svgDir = require.context('../../../assets/icons', true)

const breakpointSize: Record<TExtendedBreakpoints, string> = {
  xs: 'w-4 h-4 native:max-h-5',
  sm: 'w-5 h-5 native:max-h-5',
  xm: 'w-5 h-5 native:max-h-5',
  md: 'w-6 h-6 native:max-h-6',
  lg: 'w-7 h-7 native:max-h-7',
  xl: 'w-8 h-8 native:max-h-8',
  '2xl': 'w-9 h-9 native:max-h-9',
  '3xl': 'w-10 h-10 native:max-h-10',
}

export const Icon = ({ name, label, size = 'md', className, testID, alt, ...otherProps }: TIconProps): ReactNode => {
  const Svg = svgDir(`./${name}.svg`)?.default
  if (Svg && Platform.OS !== 'web') {
    cssInterop(Svg, {
      className: {
        target: 'style',
        nativeStyleToProp: { width: true, height: true },
      },
    })
  }

  return (
    <View
      testID={testID}
      aria-label={label}
      aria-labelledby="span"
      className={cn(size && Platform.OS !== 'web' ? breakpointSize[size] : '', className, 'native:aspect-square')}
      {...otherProps}
    >
      {Svg != null && (
        <Svg alt={alt || ''} className={cn(size && breakpointSize[size], className, 'native:aspect-square')} />
      )}
    </View>
  )
}
